import { SalesOrderWeeklySummaryComparison } from '@/hooks/api/models';
import { MotionDiv } from '@/components/element/MotionDiv';

type Props = {
  beforeSummarizedAtLabel: string;
  afterSummarizedAtLabel: string;
  weeklySummaryComparison?: SalesOrderWeeklySummaryComparison | null;
};
export const ComparisonSummaries = ({
  beforeSummarizedAtLabel,
  afterSummarizedAtLabel,
  weeklySummaryComparison,
}: Props) => {
  if (!weeklySummaryComparison) {
    return null;
  }

  return (
    <MotionDiv className="col-12">
      <div className="card mb-4">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-secondary text-xxs font-weight-bolder ps-2">フェーズ</th>
                  <th className="text-secondary text-xxs font-weight-bolder text-end pe-2">
                    {beforeSummarizedAtLabel}
                  </th>
                  <th className="text-secondary text-xxs font-weight-bolder text-end pe-2">{afterSummarizedAtLabel}</th>
                  <th className="text-secondary text-xxs font-weight-bolder text-end pe-2">差分</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[0].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[0].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[0].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[0].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[1].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[1].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[1].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[1].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[2].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[2].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[2].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[2].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[3].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[3].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[3].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[3].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[4].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[4].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[4].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[4].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[5].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[5].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[5].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[5].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[6].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[6].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[6].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[6].diff.toLocaleString()}
                  </td>
                </tr>
                <tr>
                  <td className="text-xs font-weight-bolder align-middle">
                    {weeklySummaryComparison.summaries[7].phase}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[7].before_amount.toLocaleString()}
                  </td>
                  <td className="text-xs align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[7].after_amount.toLocaleString()}
                  </td>
                  <td className="text-xs font-weight-bolder align-middle text-end">
                    ¥{weeklySummaryComparison.summaries[7].diff.toLocaleString()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MotionDiv>
  );
};
